/**Will return "26 Jul 2023"              (showTime and showSeconds = false or not set)
 *             "26 Jul 2023, 15:47"       (showTime=true)
 *             "26 Jul 2023, 15:47:15"    (showTime=true and showSeconds=true)
 */
import moment from "moment";
import "moment-timezone";

import { TimeInputFormat } from "../TimeInput/TimeInput";

const formatDateToLocaleString = (
  date: Date,
  showTime: boolean,
  showSeconds: boolean,
  showYear: boolean
): string => {
  return date.toLocaleDateString("en-GB", {
    ...(showYear && { year: "numeric" }),
    month: "short",
    day: "2-digit",
    ...(showTime && {
      hour: "2-digit",
      minute: "2-digit",
      ...(showSeconds && { second: "numeric" }),
    }),
  });
};

export const DateConversion = (
  timeStamp: number,
  showTime = false,
  showSeconds = false,
  showYear = true
) => {
  const date = new Date(Number(timeStamp));
  return formatDateToLocaleString(date, showTime, showSeconds, showYear);
};

const getTimeFromDate = (date: Date, showMs = false) => {
  const ms = showMs
    ? ":" + date.getMilliseconds().toString().padStart(3, "0")
    : "";
  return `${date.toLocaleTimeString("en-GB")}${ms}`;
};

export const DateConversionUTC = (
  timeStamp: number,
  showTime = false,
  showSeconds = false,
  showYear = true
) => {
  const date = new Date(Number(timeStamp));
  const dateUTC = new Date(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds(),
    date.getUTCMilliseconds()
  );
  return formatDateToLocaleString(dateUTC, showTime, showSeconds, showYear);
};

/**Will return "15:47:15"          (showMs=false or not set)
 *             "15:47:15:022"      (showMs=true)
 */
export const TimeConversion = (timeStamp: number, showMs = false) => {
  const date = new Date(Number(timeStamp));
  return getTimeFromDate(date, showMs);
};

export const TimeConversionUTC = (timeStamp: number, showMs = false) => {
  const date = new Date(Number(timeStamp));
  const dateUTC = new Date(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds(),
    date.getUTCMilliseconds()
  );
  return getTimeFromDate(dateUTC, showMs);
};

export const extractDateOnly = (dateTime: Date) => {
  // Convert the Date object to a string
  const dateTimeString = dateTime.toString();

  // Split the date and time parts
  const parts = dateTimeString.split(" ");

  // Join the first 4 parts to get the date
  const dateOnly = parts.slice(0, 4).join(" ");

  return dateOnly;
};

export const fromTimeInput = (fromDate: Date): TimeInputFormat => {
  return {
    hours: `${moment(fromDate).format("HH")}`,
    minutes: `${moment(fromDate).format("mm")}`,
    seconds: `${moment(fromDate).format("ss")}`,
  };
};

export const formatTime = (timeObj: TimeInputFormat) => {
  const { hours, minutes, seconds, milliseconds } = timeObj;

  // Ensure that hours, minutes, and seconds are two digits by padding with zeros if necessary
  const formattedHours = hours.padStart(2, "0");
  const formattedMinutes = minutes.padStart(2, "0");
  const formattedSeconds = seconds?.padStart(2, "0");
  const formattedMilliseconds = milliseconds
    ? String(milliseconds).padStart(3, "0")
    : "000";

  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}:${formattedMilliseconds}`;
};

export const convertToUnixTimestamp = (dateStr: string, timeStr: string) => {
  const dateTimeStr = dateStr + " " + timeStr;
  const dateTimeObj = new Date(dateTimeStr);
  const unixTimestamp = Math.floor(dateTimeObj.getTime() / 1000) * 1000;
  return unixTimestamp;
};
